import { IAugmentedJQuery, IControllerLocals, IScope } from 'angular';

export class ModalLocals implements IControllerLocals {

  constructor( public $scope: IScope,
               public $element: IAugmentedJQuery,
               public close: ( result: any, delay?: number ) => void ) {
  }
}



// WEBPACK FOOTER //
// ./app/components/modals/gmc-modal/shared/modal-locals.ts